import template from "./log-in-page.html";

const LogInPageComponent = {
  template: template,

  controller: class LogInPageController {
    /* @ngInject */
    constructor(
      $rootScope,
      $scope,
      $state,
      $timeout,
      $filter,
      User,
      SecurityManager,
      SweetAlertService,
      Utils,
      moment,
    ) {
      this.$rootScope = $rootScope;
      this.$scope = $scope;
      this.$state = $state;
      this.$timeout = $timeout;
      this.$filter = $filter;
      this.User = User;
      this.SecurityManager = SecurityManager;
      this.SweetAlertService = SweetAlertService;
      this.Utils = Utils;
      this.moment = moment;
    }

    $onInit() {
      this.loading = false;
      this.email = null;
      this.emailResetPassword = null;
      this.showLogin = true;
      this.showResetPassword = false;
      this.password = null;
      this.rememberMe = false;
      this.error = false;
      this.cardError = false;

      if (this.SecurityManager.isAuthenticated()) this.$timeout(() => this.$state.go("index"), 100);

      this.$scope.$watch(
        () => this.password,
        (newVal, oldVal) => {
          if (this.error && !angular.equals(newVal, oldVal)) this.error = false;
        },
      );
    }

    logIn() {
      this.error = false;
      this.cardError = false;
      if (this.form.$valid) {
        this.loading = true;
        this.SecurityManager.authenticate(this.email, this.password)
          .then((user) => {
            this._onLogInSuccess(user);
          })
          .catch((error) => {
            this._onLogInError(error);
          });
      }
    }

    goResetPassword() {
      this.showLogin = false;
      this.showResetPassword = true;
    }

    goLogin() {
      this.showLogin = true;
      this.showResetPassword = false;
    }

    async resetPassword() {
      if (!this.formResetPassword.$valid) return;
      this.loading = true;
      try {
        await this.User.resetPassword(this.emailResetPassword);
        await this.SweetAlertService.resetedPassword(this.emailResetPassword);
      } catch (e) {
        await this.SweetAlertService.errorResetingPassword();
      }

      this.loading = false;
      this.$rootScope.$applyAsync();
    }

    _onLogInSuccess(user) {
      this.SecurityManager.storeCredentials(user.accessToken, this.rememberMe);
      this.$rootScope.user = user;

      if (this.$rootScope.returnToState !== null) {
        const state = this.$rootScope.returnToState.state;
        const params = this.$rootScope.returnToState.params;
        this.$rootScope.returnToState = null;
        this.$state.go(state, params);
      } else {
        this.$state.go("index");
      }
    }

    _onLogInError(e) {
      if (e.data === "Invalid email or password") {
        this.error = this.$filter("trans")("errors.auth.invalidPasswordOrEmail");
      } else if (e.data === "User is blocked") {
        this.error = this.$filter("trans")("errors.auth.blockedUser");
      } else if (e.data && e.data.indexOf("Too many failed attempts") !== -1) {
        const nextValidRequestDate = e.data.split("~")[1];
        const nextValidRequestDateText = this.moment(nextValidRequestDate).fromNow();
        this.error = this.$filter("trans")("errors.auth.failedAttempts", nextValidRequestDateText);
      } else if (e.data === "Email hasn't been verified before access token expiration date") {
        this.error = this.$filter("trans")("errors.auth.emailNotVerified");
      } else if (e.data === "User is not registered") {
        this.cardError = this.$filter("trans")("errors.auth.userIsNotRegistered");
      } else {
        throw e;
      }

      this.loading = false;
    }
  },
};

export default LogInPageComponent;
